import { render, staticRenderFns } from "./blogs-article.vue?vue&type=template&id=62a57aa8&scoped=true"
import script from "./blogs-article.vue?vue&type=script&lang=js"
export * from "./blogs-article.vue?vue&type=script&lang=js"
import style0 from "./blogs-article.vue?vue&type=style&index=0&id=62a57aa8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a57aa8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VImg: require('/var/www/tubber-new/components/global/v/img.vue').default,VBreadcrumbs: require('/var/www/tubber-new/components/global/v/breadcrumbs.vue').default,VButton: require('/var/www/tubber-new/components/global/v/button.vue').default,VCarousel: require('/var/www/tubber-new/components/global/v/carousel.vue').default,RequestAction: require('/var/www/tubber-new/components/global/RequestAction.vue').default,BaseModal: require('/var/www/tubber-new/components/global/base-modal.vue').default})
